import { Navigate } from 'react-router-dom'
import { useTemplateTabs } from 'app/components/templates/useTemplateTabs'

// The templates hub lands on its first available tab. SMS templates are gated
// on the workspace having a location with the Inbox product, so a workspace
// without one goes straight to Tasks.
export default function SettingsTemplatesIndex(): React.ReactElement {
  const { smsEnabled } = useTemplateTabs()
  // Wait for the capability answer so we never bounce a valid SMS workspace.
  if (smsEnabled === undefined) return <></>
  return <Navigate to={smsEnabled ? `/settings/templates/sms` : `/settings/templates/tasks`} replace />
}
